import {
  Modal,
  Text,
  MultiSelect,
  Textarea,
  Button,
  Group,
} from "@mantine/core";
import { useAppDispatch, useAppSelector } from "../../store/hooks";
import { setActiveModal } from "../../store";
import { useState } from "react";
import { SKIP_REASONS } from "../../config/data";
import { useSkipJobTask } from "@labeling-tools/api/lebron/react-query-hooks";
import { useParams } from "react-router-dom";
import { useQueryClient } from "@tanstack/react-query";

export const SkipModal = ({ task_id }: { task_id: string }) => {
  const dispatch = useAppDispatch();
  const queryClient = useQueryClient();
  const { jobId } = useParams();
  const isOpen = useAppSelector((state) => state.oos.activeModal === "skip");
  const [skipReasons, setSkipReasons] = useState<string[]>([]);
  const [skipNotes, setSkipNotes] = useState<string | null>(null);

  const { mutateAsync: skipJobTask, isPending: isSkipping } = useSkipJobTask(
    jobId || "",
    task_id,
  );

  const handleCancelSkip = () => {
    dispatch(setActiveModal(null));
  };

  const handleConfirmSkip = async () => {
    try {
      await skipJobTask({
        result: {
          skip_reasons: skipReasons,
          skip_notes: skipNotes,
        },
      });
      dispatch(setActiveModal(null));
      queryClient.invalidateQueries({ queryKey: ["nextPendingTask", jobId] });
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <Modal
      opened={isOpen}
      onClose={handleCancelSkip}
      title={<Text fw={600}>Skip Task</Text>}
      centered
      withinPortal={false}
    >
      <div className="flex flex-col gap-4">
        <div>
          <MultiSelect
            label="Skip Reasons"
            placeholder="Select one or more reasons"
            data={SKIP_REASONS}
            value={skipReasons}
            onChange={setSkipReasons}
            withAsterisk
            labelProps={{ style: { textAlign: "left" } }}
          />
        </div>
        <div>
          <Textarea
            label="Additional Notes (optional)"
            placeholder="Add any helpful details"
            minRows={3}
            value={skipNotes || ""}
            onChange={(e) => setSkipNotes(e.currentTarget.value)}
          />
        </div>
        <Group justify="flex-end" mt="sm">
          <Button variant="subtle" color="gray" onClick={handleCancelSkip}>
            Cancel
          </Button>
          <Button
            onClick={handleConfirmSkip}
            disabled={skipReasons.length === 0}
            loading={isSkipping}
          >
            Confirm Skip
          </Button>
        </Group>
      </div>
    </Modal>
  );
};
